import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompilationModel } from '../../../../../@models/erp/compilation';
import { LineItemModel } from '../../../../../@models/erp/lineItem';

export class DownstreamLineItems {
  lineItems: LineItemModel[];
  split: boolean;
}

@Component({
  selector: 'ngx-line-item-remaining',
  templateUrl: './line-item-remaining.component.html',
  styleUrls: ['./line-item-remaining.component.scss'],
})
export class LineItemRemainingComponent implements OnInit {

  @Input() compilation: CompilationModel;
  @Input() typeName: string;
  @Output() newDownstreamDocFromLineItems: EventEmitter<DownstreamLineItems> = new EventEmitter<DownstreamLineItems>()

  checked: boolean[] = [];
  downstreamLineItems: DownstreamLineItems = new DownstreamLineItems();

  constructor() { }

  ngOnInit() {
    this.compilation.lineItems && this.compilation.lineItems.forEach((el, idx) => {
      this.checked[idx] = false;
    })
  }

  split(selectedOnly = false) {
    if (selectedOnly) {
      this.downstreamLineItems.lineItems = this.compilation.lineItems.filter((el, idx) => this.checked[idx] === true);
    } else {
      this.downstreamLineItems.lineItems = this.compilation.lineItems;
    }
    this.downstreamLineItems.split = true
    this.newDownstreamDocFromLineItems.emit(this.downstreamLineItems);
  }

  create() {
    const lineItems = this.compilation.lineItems.filter((el, idx) => this.checked[idx] === true);
    this.downstreamLineItems.lineItems = lineItems;
    this.downstreamLineItems.split = false
    this.newDownstreamDocFromLineItems.emit(this.downstreamLineItems);
  }

}
